/// <amd-module name="Artifacts/Nuget/components/Logo" />

import * as NugetRes from "Artifacts/Nuget/Resources";
import { ILogoProps } from "Artifacts/Package/types/ILogoProps";
import * as React from "react";
import { Components, useComponentContext } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Image } from "VSSUI/Image";

export const logoContributionId = "ms.azure-artifacts.protocol-nuget.logo";

const Logo: React.FC<ILogoProps> = ({ className }) => {
  const { pageContext } = useComponentContext();

  return (
    <Image
      className={className}
      alt={NugetRes.Logo_NuGet}
      src={getAssetLocation(pageContext, "ms.azure-artifacts/protocol-nuget/img/nuget.svg")}
    />
  );
};

Components.add(logoContributionId, Logo);

export { Logo };
